import apiClient from '@/lib/api-client'

export interface Workspace {
  id: string
  name: string
  ownerId: string
  settings: Record<string, any>
  isDeleted: boolean
  createdAt: string
  updatedAt: string
}

export interface CreateWorkspaceRequest {
  name: string
}

export interface UpdateWorkspaceRequest {
  name?: string
  settings?: Record<string, any>
}

export interface WorkspacesResponse {
  success: boolean
  data: { data: { workspaces: Workspace[] } }
  message: string
}

export interface WorkspaceResponse {
  success: boolean
  data: { workspace: Workspace }
  message: string
}

export const getWorkspaces = async (): Promise<WorkspacesResponse> => {
  const response = await apiClient.get<WorkspacesResponse>('/workspaces')
  return response.data
}

export const createWorkspace = async (data: CreateWorkspaceRequest): Promise<WorkspaceResponse> => {
  const response = await apiClient.post<WorkspaceResponse>('/workspaces', data)
  return response.data
}

export const getWorkspace = async (id: string): Promise<WorkspaceResponse> => {
  const response = await apiClient.get<WorkspaceResponse>(`/workspaces/${id}`)
  return response.data
}

export const updateWorkspace = async (
  id: string,
  data: UpdateWorkspaceRequest
): Promise<WorkspaceResponse> => {
  const response = await apiClient.patch<WorkspaceResponse>(`/workspaces/${id}`, data)
  return response.data
}

export const deleteWorkspace = async (id: string): Promise<void> => {
  await apiClient.delete(`/workspaces/${id}`)
}

export const restoreWorkspace = async (id: string): Promise<WorkspaceResponse> => {
  const response = await apiClient.post<WorkspaceResponse>(`/workspaces/${id}/restore`)
  return response.data
}
